import http from './http' // needs this file in the same directory
import {The_Ability} from '../store/index'

export default {
  index(filter){
    return http.get(`/departments`, {params: {...filter}});
  },

  show(item_id){
    return http.get(`/departments/`+item_id);
  },

  create(new_item){
    if (The_Ability.can('create', 'Department')){
      return http.post(`/departments`,{
        department:{ 
          name: new_item.name,
          parent_id: new_item.parent_id,
          company_id: new_item.company_id,
          ancestry: new_item.ancestry,
        }
      });
    } else {
      return false
    }
  },

  update(update_item){
    if (The_Ability.can('update', 'Department')){
      return http.put(`/departments/${update_item.id}`,{
        department:{ 
          id: update_item.id,

          name: update_item.name,
          parent_id: update_item.parent_id,
          company_id: update_item.company_id,
          ancestry: update_item.ancestry,
        }
      });
    } else {
      return false
    }
  },

  updateToDelete(update_item){
    return http.delete(`/departments/${update_item}`);
  },

  delete(item){
    return http.delete(`/departments/${item.id}`);
  },

  associations(dept_id, solution_id) {
    return http.get(`/departments/${dept_id}/associations`, {params: {
      solution_id: solution_id
    }});
  },

  moveAssociations(dept) {
    return http.put(`/departments/${dept.id}/move_associations`, {
      department: {
        id: dept.id,
        name: dept.name,
        parent_id: dept.parent_id,
        company_id: dept.company_id,
        ancestry: dept.ancestry,
        solution_id: dept.solution_id,
        associations: {...dept.associations}
      }
    })
  }
}